<template>
  <v-select
    v-model="pageSize"
    label="Show"
    :items="pageSizes"
    item-text="name"
    item-value="id"
    class="width-5em flex-grow-0"
  />
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "PageSize",
  props: {
    total: {
      type: Number,
      default: () => 1,
      required: true
    }
  },
  data: () => ({
    size: 1
  }),
  watch: {
    size: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("input", newValue);
      }
    },
    total: function(newValue, oldValue) {
      if (this.size === oldValue) {
        this.size = newValue;
      }
    }
  },
  computed: {
    ...mapGetters({
      defaultPageSize: "ui/defaultPageSize"
    }),
    pageSize: {
      get() {
        return this.size > this.total ? this.total : this.size;
      },
      set(size) {
        this.size = size;
      }
    },
    pageSizes() {
      return [
        { id: 10, name: 10 },
        { id: 50, name: 50 },
        { id: 100, name: 100 },
        { id: this.total, name: "all" }
      ];
    }
  },
  created() {
    this.size = this.defaultPageSize;
  }
};
</script>
